export const BASKET_ID_KEY = 'basketId';
